import React from 'react';
import PropTypes from 'prop-types';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import useIntl from '@afosto/utils-react/intl/useIntl';
import useForm from '@afosto/utils-react/validation/useForm';
import Form from '../Form';
import FormActions from '../Form/FormActions';
import TextField from '../TextField';
import translations from './translations';
import validationSchema from './validations';

const ConversationForm = ({ onSubmit, onCancel }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    defaultValues: {
      content: '',
    },
    clearOnSubmit: true,
    onSubmit,
    onCancel,
  });

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form} renderActions={false}>
        <TextField
          name="content"
          label={intl.formatMessage(translations.fields.content.label)}
          multiline
          rows={4}
        />

        <FormActions
          primaryAction={{
            label: intl.formatMessage(translations.formActions.createComment),
            onClick: form.onSubmit,
            type: 'submit',
            color: 'primary',
            variant: 'contained',
          }}
        />
      </Form>
    </LoadingWrapper>
  );
};

ConversationForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

ConversationForm.defaultProps = {
  onSubmit: undefined,
  onCancel: undefined,
};

export default ConversationForm;
